import { BuiltinType } from './types';
export class BuiltinMemberCall {
    constructor() {
        this.types = new Set([BuiltinType.MemberCall]);
    }
}

//# sourceMappingURL=BuiltinMemberCall.js.map
